import React from 'react';
import { Permission } from '../../data/models/permission.model';
import { useAppSelector } from '../useAppSelector';
import { useHasPermission } from './useHasPermission';
import * as userSlice from '../../data/user.slice';

export const useIsPRUser = (): boolean | null => {
  const [isPRUser, setIsPRUser] = React.useState<boolean | null>(null);
  const user = useAppSelector(userSlice.selectUserInfo);

  // Right now PR users/admins have only notes related permissions so
  // I'm using that. I think it would really make more sense to have
  // a specific permission for this but for now I will use this. It
  // sounds like this is a temporary thing anyway.
  const notesReadPermission: Permission = {
    resource: 'notes',
    action: 'readbasic',
    scope: 'all',
  };

  const hasPRUserPermission = useHasPermission(user, notesReadPermission);

  React.useEffect(() => {
    setIsPRUser(hasPRUserPermission);
  }, [hasPRUserPermission]);

  return isPRUser;
};
